import NewsletterFormExt from '_core_ext/components/forms/NewsletterForm';

export default class NewsletterForm extends NewsletterFormExt {
    init() {
        super.init();
        this.event('change', '.f-subscribe-form .js-newsletter-email input[type=email]', this.emailShowIcon);
        this.event('change', '.js-notifyme-acceptlettersubscription', this.acceptNewsletter);
        this.event('blur', '.js-newsletter-email input[type=email]', this.newsletterEmailErrors);
        this.expandReadMore();
    }

    expandReadMore() {
        var showReadMoreFooterBlock =  $('.show-read-more-footer .form-row_label.js-input-label');
        if (showReadMoreFooterBlock) {
            var readMoreseo = Resources.VIEWMORE;
            var readLessseo = Resources.VIEWLESS;
            let $readMoreFooterBlock = $('.read-more-footer');
            if(!$readMoreFooterBlock.length){
            $('<a href="javascript:void(0);" class="read-more-footer"><span class="read-more-text-footer">' + readMoreseo + '</span></a>').insertAfter($(showReadMoreFooterBlock));
            var showReadMoreFooter = $(".show-read-more-footer");
            var readMoreFooter = $(".read-more-footer");
            var readMoreTextFooter = readMoreFooter.find('.read-more-text-footer');
            readMoreFooter.click(function () {
                    if(!readMoreFooter.hasClass('read-less')){
                        readMoreTextFooter.text(readLessseo);
                        $(readMoreFooter).addClass('read-less');
                        $(showReadMoreFooter).addClass('read-less');
                    }else{
                        readMoreTextFooter.text(readMoreseo);
                        $(readMoreFooter).removeClass('read-less');
                        $(showReadMoreFooter).removeClass('read-less');
                    }
                });
            }    
        }
    }

    newsletterEmailErrors(){
        let newsletterEmailFailure = $('.js-newsletter-email .subscriptionfailure');
        if(newsletterEmailFailure.length > 0){
            newsletterEmailFailure.remove();
        }
    }

    emailShowIcon() {
        let emailField = $('.f-subscribe-form .js-newsletter-email');
        emailField.removeClass('error valid');
        if (!$('.f-subscribe-form .js-newsletter-email input[type=email]').valid()) {
            emailField.addClass('error');
        } else {
            emailField.addClass('valid');
        }
    }

    acceptNewsletter(el, event) {

        if ($('.js-notifyme-acceptlettersubscription').is(':checked')) {
            //console.log("Checked");
        }else{
            //cosnole.log("unchecked");
        }
        
    }

    onSubmitSuccess(result) {
        this.$el.trigger('newsletterSubscription.success', [this.$el]);
        $('#header-top-banner, #header-bottom-banner, .js-header-nav-container, .header__menu-utility, .js-menu-tab-content').removeClass('d-none');
        $('#logo').removeClass('logo-space');
        this.$el.find('.js-emailform-wrapper').hide();
        this.$el.find('.js-toggle_content').hide();
        if(result.displayDoubleOptinMessage){
            this.$el.find('.msg-with-email-icon i.mail-icon').fadeIn();
            this.$el.find('.js-result_message-double-optin').fadeIn();
            this.$el.find('.js-result_message-double-optin').parents('.c-account__content').find('.c-registration__title').hide();
            this.$el.find('.js-result_message-double-optin').parents('.c-account__content').find('.c-subscribe-form__not-subscribed-msg').hide();
            this.$el.find('.js-result_message-double-optin').parents('.c-account__content').find('.c-subscribe-form__not-subscribed-joinnewsletter').hide();
        }else {
            this.$el.find('.msg-with-check-icon i.check-icon').fadeIn()
            this.$el.find('.js-result_message-not-double-optin').fadeIn();
            this.$el.find('.js-result_message-not-double-optin').parents('.c-account__content').find('.c-registration__title').hide();
            this.$el.find('.js-result_message-not-double-optin').parents('.c-account__content').find('.c-subscribe-form__not-subscribed-msg').hide();
            this.$el.find('.js-result_message-not-double-optin').parents('.c-account__content').find('.c-subscribe-form__not-subscribed-joinnewsletter').hide();
        }
        this.$el.find('.js-result_message').fadeIn();
        this.$el.find('.js-result_message').parents('.c-account__content').addClass('user-subscribed');
        this.$el.find('.js-result_message').parents('.c-account__content').find('.c-registration__title').hide();
        this.$el.find('.js-result_message').parents('.c-account__content').find('.c-subscribe-form__subscribed-msg').hide();
        this.$el.get(0).reset();
    }
}